import { render, staticRenderFns } from "./NovaEdicaoDeLoja.vue?vue&type=template&id=0feccd0d&scoped=true&"
import script from "./NovaEdicaoDeLoja.vue?vue&type=script&lang=ts&"
export * from "./NovaEdicaoDeLoja.vue?vue&type=script&lang=ts&"
import style0 from "../estilos-da-tela-de-loja.css?vue&type=style&index=0&lang=css&"
import style1 from "./NovaEdicaoDeLoja.vue?vue&type=style&index=1&id=0feccd0d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0feccd0d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VIcon,VImg,VProgressLinear,VTextField})
